module.exports = __webpack_public_path__ + "static/image/sustainability/img-happiness-2025.ver2_0_2.jpg?6502c718";